<template>
  <div class="main-body">
    <div class="header">机构配餐计划</div>
    <div class="out">

      <div class="search2">

        <el-button type="primary" size="mini" @click.native="toggleModalAdd">添加</el-button>
        <el-button type="success" size="mini" @click.native="handleEdit">编辑</el-button>
        <el-button type="info" size="mini" @click.native="handleInfo">菜谱信息</el-button>

        <div style="float:right">
          <el-date-picker size="mini"
              ref="picker"
              v-model="datetimerangeValue"
              type="daterange"
              :clearable='false'
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              style="width:230px;margin-right:10px">
          </el-date-picker>
          <el-button size="mini" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>

      <div :style="styleTh">
        <el-calendar v-model="calendarDate" :range='range'>
          <template slot="dateCell" slot-scope="{date, data}">

            <p :class="isSelecteds(date) ? 'is-selected' : ''">
              {{ data.day.split('-').slice(1).join('-') }} {{ isSelecteds(date) ? '✔️' : ''}}
            </p>

            <el-popover v-if="getDayInfo(date)"
                placement="top-start" width="150" trigger="hover">
              <el-button slot="reference" size="small" type="text">已排班</el-button>


              <div>
                <div>早餐</div>
                <span v-for="item in getDayInfo(date).dishesPlanMorningDTO.listDishesPlanMorningItem" :key="item.dishesCode">
                    <span v-show="item.dishesName">菜品：{{item.dishesName}}<br></span>
                </span>
              </div>

              <div>
                <div>中餐</div>
                <span v-for="item in getDayInfo(date).dishesPlanNoonDTO.listDishesPlanNoonItem" :key="item.dishesCode">
                    <span v-show="item.dishesName">菜品：{{item.dishesName}}<br></span>
                </span>
              </div>
              <div>
                <div>晚餐</div>
                <span v-for="item in getDayInfo(date).dishesPlanNightDTO.listDishesPlanNightItem" :key="item.dishesCode">
                    <span v-show="item.dishesName">菜品：{{item.dishesName}}<br></span>
                </span>
              </div>


            </el-popover>

          </template>
        </el-calendar>
      </div>

    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd"
         v-bind:dishesList="dishesList" v-on:getList="getList"></Add>
    <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit"
          v-bind:dishesList="dishesList" v-on:getList="getList"></Edit>
    <Info ref="myInfo" v-show="showModalInfo" v-on:closeInfo="closeInfo"
          v-bind:dataList="tableData"></Info>

  </div>
</template>

<script>

import {timeStr,timefilters} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";

import Edit from "./Edit";
import Add from "./Add";
import Info from "./Info";

export default {
  name: "Role",
  data(){
    return{
      loading:false,

      showModalAdd:false,
      showModalEdit:false,
      showModalInfo:false,

      dishesList:[],

      tableData:[],

      dateList:[],
      datetimerangeValue:'',
      calendarDate:'',
      range:[],

      th:0,
      styleTh:{
        height:'',
        background:'#fff',
        'overflow-y':'auto'
      },

    }
  },
  components:{
    Add,Edit,Info
  },
  created(){
    this.init();

    this.th = this.$store.state.tableHeight;
    this.styleTh.height=this.$store.state.tableHeight+50+'px';
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
      this.styleTh.height=val+50+'px';
    },
    calendarDate(val){
      this.getDate(val)
    }
  },
  methods:{
    init(){

      const start= new Date();
      const end=new Date(start.getTime() + 1000 * 60 * 60 * 24 * 15);
      this.datetimerangeValue=[start, end];

      this.getWeekDate(this.datetimerangeValue);

      this.getList();

      this.getDishesList();

    },

    getDishesList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Dishes/List",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode:getStaffCode(),
        }
      }).then((response) => {
            if (response.data.error == 0) {
              this.dishesList=response.data.data
            }else if(response.data.error == 1){
              this.$message({type: 'info', message: response.data.message});
            }
          })
    },



    getWeekDate(date){

      var startDate=new Date(date[0]);
      startDate.setDate(startDate.getDate() - startDate.getDay() + 1);

      var endDate=new Date(date[1])
      endDate.setDate(endDate.getDate() - endDate.getDay() + 7);

      this.range=[timefilters(startDate).slice(0,10),timefilters(endDate).slice(0,10)];

    },

    timefilter(row, column, cellValue){
      return timefilters(cellValue)
    },

    isSelecteds(date){
      var list=this.dateList
      var getDate=timefilters(date).slice(0,10)
      if(list.indexOf(getDate)>-1){
        return true
      }
      return false
    },

    getDayInfo(data){

      var list=this.tableData;
      var row='';

      console.log(timefilters(data)+list+"--1");

      if(list){
        list.forEach(element => {
          if(timefilters(element.time).slice(0,10)==timefilters(data).slice(0,10)){
            row=element
          }
        });
      }

      return row
    },

    getDate(date){
      var newDate=timefilters(new Date()).slice(0,10)
      var getDate=timefilters(date).slice(0,10)
      if(new Date(newDate)<=new Date(date)){
        var list=this.dateList
        if(list.indexOf(getDate)>-1){
          list.splice(list.indexOf(getDate), 1)
        }else{
          list.push(getDate)
        }
        this.dateList=list
      }
      else{
        this.$message.error('只能编辑今天及以后的排班')
      }
    },




    toggleModalAdd:function(){

      if(!this.dateList.length){
        this.$message.error('请选择排班日期')
        return
      }

      var row;
      for(var i in this.dateList){
        if(this.getDayInfo(this.dateList[i])){
          this.$message.error('请去除已排班日期，已排班日期可通过修改编辑')
          row=this.getDayInfo(this.dateList[i])
          break;
        }
      }

      if(!row){
        this.showModalAdd = true;
        this.$refs.myAdd.init(this.dateList);
      }

    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },

    handleEdit() {

      if(!this.dateList.length){
        this.$message.error('请选择排班日期')
        return
      }
      if(this.dateList.length>1){
        this.$message.error('只能编辑单个排班')
        return
      }
      var row=this.getDayInfo(this.dateList[0])
      if(!row){
        this.$message.error('请先添加,再修改')
        return
      }
      this.$refs.myEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },

    handleInfo(){
      this.showModalInfo=true
      this.$refs.myInfo.init();
    },
    closeInfo:function(){
      this.showModalInfo = !this.showModalInfo;
    },


    getList(){
      this.loading = true;

      this.getWeekDate(this.datetimerangeValue);

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"DishesPlan/InsPage",
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          startTime:this.range[0],
          endTime:this.range[1],
        }
      }).then( (response)=> {
        this.loading = false;
        if(response.data.error == 0){
          this.tableData = response.data.data;
          console.log(this.tableData);
          this.dateList=[];
        }
      }).catch(function (error) {
        console.log(error);
      });
    },



  }
}
</script>
<style lang="scss" scoped>

</style>
